var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-select"},[_c('button',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(() => (_vm.isOpen = false)),expression:"() => (isOpen = false)"}],ref:"statusButton",staticClass:"status-select__button",class:[
      { green: _vm.status.class === 'green' },
      { red: _vm.status.class === 'red' }
    ],on:{"click":function($event){$event.stopPropagation();_vm.isOpen = !_vm.isOpen}}},[_c('div',{staticClass:"status-select__button__arrow",class:{ 'is-open': _vm.isOpen }},[_c('icon',{attrs:{"name":"arrow-down-icon"}})],1),_vm._v(" "),_c('div',{staticClass:"status-select__button__text",class:[
        { green_text: _vm.status.class === 'green' },
        { red_text: _vm.status.class === 'red' }
      ]},[_vm._v("\n      "+_vm._s(_vm.status.text)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"status-select__button__status",class:[
        { green: _vm.status.class === 'green' },
        { red: _vm.status.class === 'red' }
      ]})]),_vm._v(" "),_c('ul',{ref:"statusMenu",staticClass:"status-select__list"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"status-select__list__item",class:[
        { green: item.class === 'green' },
        { red: item.class === 'red' }
      ],on:{"click":function($event){$event.stopPropagation();return _vm.selectedContext(item)}}},[_c('div',{staticClass:"status-select__list__item__text",class:[
          { green_text: item.class === 'green' },
          { red_text: item.class === 'red' }
        ]},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"status-select__list__item__status",class:[
          { green: item.class === 'green' },
          { red: item.class === 'red' }
        ]})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }